﻿import Vue from "vue";
import common = require("../../common");
import core = require("../../core");
import HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction");
import utilities = require("../utilities");
import FormService = require("../../services/FormService");
import SharedEmbeddedParentForm = require("../vue/hotEditable/SharedEmbeddedParentForm");
import GestionPersonneFermeVue = require("../vue/GestionPersonneFermeVue");
import context = require("../context");
import PageService = require("../../services/PageService");

//declare function require(name: string): any;
//var jsClasses = require("../../../js/jsClasses");

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    /** Default: TRUE */
    loadFormModeFromUrl?: boolean;
    /** Determine si le webComponent est un embeddedContent (CollapsableForm, EmbeddedForm, etc.) */
    embeddedContentModels: common.IEmbeddedContentModel[];
    concurrencySumCheck?: string;
    /** Definie sur le mode "Edition" est constant ou s'il est "togglable" (default: false) */
    isEditionAlwaysOn?: boolean;
    bag?: {};
    /** Definie si, en mode "Edition", le formulaire doit avoir un bouton de sauvegarde ou si la sauvegarde est effectuee lors des changements de valeurs des champs (default: false) */
    liveUpdateOnEditMode?: boolean;
    liveUpdateOnEditModeIgnoredFieldNames?: string[];
    disableManageButtonsOnFormModeChange?: boolean;
    disabledButtonsByDefaultFieldConfig?: common.IHotFormDisabledButtonByDefaultFieldConfig[];
    /** Default: TRUE */
    focusFirstFieldOnEdition?: boolean;
    /** Default: TRUE */
    appendToContextualComponents?: boolean;
    // Specific
    autoSearch?: boolean;
    exemptionVoteAndCotiLinked: boolean;
}
interface IResponseData extends common.IHotEditableFormResponseData {
    searchPersonneResultOptions?: common.IHotEditableSelectOption[];
    searchPersonneResultSelectedOption?: common.IHotEditableSelectOption;
}
/** Preconfigure pour utilisation en tant que widget */
class GestionPersonneFerme implements common.IWebComponent {
    private _isInit = false;
    private _formService: FormService;
    private _pageService: PageService;
    private _editVue = null as GestionPersonneFermeVue;
    private _loader = null as core.Loader;
    private _previousPageUrl: string;
    private _vueElId: string;
    private _updateApiUrl: string;
    private _liveUpdateOnEditMode: boolean;
    private _liveUpdateOnEditModeIgnoredFieldNames: string[];
    private _isEditionAlwaysOn: boolean;
    private _confirmPopup: core.ConfirmationPopup = null;
    private _disabledButtonsByDefaultFieldConfig: common.IHotFormDisabledButtonByDefaultFieldConfig[];
    private _useBrowserHistoryToGoBackOnCancel: boolean;
    onFormActionSuccessCallback = null as (action: HotEditableFormAction, data?: common.IHotEditableFormResponseData) => void;
    // Specific
    private _isPersonneMorale = false;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = s.isEditionAlwaysOn !== false;//default=TRUE
        this._liveUpdateOnEditMode = s.liveUpdateOnEditMode === true;//default is FALSE
        this._liveUpdateOnEditModeIgnoredFieldNames = s.liveUpdateOnEditModeIgnoredFieldNames || [];
        this._disabledButtonsByDefaultFieldConfig = s.disabledButtonsByDefaultFieldConfig || [];
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl || null;

        this._pageService = new PageService();
        this._formService = new FormService(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this.setupVue(s);

        return this;
    }

    destroy() {
        this._editVue.shared.destroyComponents();
        this._editVue.$destroy();
        this._editVue = null;
    }
    setSharedEmbeddedParentForm(shared: SharedEmbeddedParentForm) {
        this._editVue.shared.setSharedEmbeddedParentForm(shared);
        return this;
    }
    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue.shared.getFormName(), navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue.shared.getFormName(), sumCheck);
    //     return this;
    // }
    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            bag: s.bag || null,
            loadFormModeFromUrl: false,
            embeddedContentModels: s.embeddedContentModels || null,
            includesConcurrencySumCheck: true,
            concurrencySumCheck: s.concurrencySumCheck || null,
            exemptionVoteAndCotiLinked: s.exemptionVoteAndCotiLinked === true,
            autoSearch: s.autoSearch === true
        };

        this._editVue = new GestionPersonneFermeVue();

        if (s.disableManageButtonsOnFormModeChange === true)
            this._editVue.setManageButtonsOnFormModeChange(false);
        else
            this.autoDisabledButtons();

        this._editVue.shared.setActionCallback(a => {
            this.onFormAction(a);
        }).setErrorCallback((errors, config) => {
            this.onFormActionError(errors, null, config);
        });
        this._editVue.shared.setupForm(this._isEditionAlwaysOn, s.focusFirstFieldOnEdition);
    }
    refreshEmbeddedComponents() {
        if (this._editVue)
            this._editVue.refreshEmbeddedComponents();
    }
    private autoDisabledButtons() {
        const configurations = [
            {
                buttonName: "Search",
                fields: [
                    {
                        name: "Nom",
                        condition: value => !value
                    }
                ],
                fieldsConditionalClause: 'or'
            }
        ] as common.IHotFormDisabledButtonByDefaultFieldConfig[];
        if (!this._isPersonneMorale)
            configurations[0].fields.push({
                name: "Prenom",
                condition: value => !value
            });

        utilities.disabledHotEditableButtonsByConfigurations(configurations, this._editVue.formManager);
    }
    private onFormAction(action: HotEditableFormAction) {
        if (this._formService.actionHasError(action))
            return;

        this.autoDisabledButtons();

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (action && action.isFieldChanged()) {
            const isPersonneMoraleCheckboxClick = action.getFieldName() === "EstPersonneMorale";
            if (isPersonneMoraleCheckboxClick)
                this._isPersonneMorale = this._editVue.onEstPersonneMoralUpdate();
        }

        if (this._liveUpdateOnEditMode) {
            const isExcluded = utilities.any(this._liveUpdateOnEditModeIgnoredFieldNames, x => x === action.getFieldName());
            if (isExcluded)
                return;
            else if (actionType === common.HotEditableActionTypes.unknown) 
                actionType = common.HotEditableActionTypes.update;
        }

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel && this._previousPageUrl) {
            utilities.redirect(this._previousPageUrl);
            return;
        }

        if (actionType === common.HotEditableActionTypes.apply) {
            if (actionValue === "search")
                this._editVue.setSearchPersonneResultsIsRunning();
        }

        const post = () => {
            this._formService.validateAndPost(
                this._updateApiUrl,
                null,
                {
                    posted_actionType: actionType,
                    posted_actionValue: actionValue,
                    posted_formName: this._editVue.shared.getFormName(),
                    posted_fieldName: action.getFieldOrButtonName(),
                    posted_currentCulture: context.culture.get(),
                    posted_currentUrl: utilities.currentUrl(),
                    posted_previousPageUrl: this._previousPageUrl,
                    posted_customData: utilities.ensureCustomDataIsValid(),
                    posted_currentEmbeddedComponentName: this._editVue.shared.getCurrentEmbeddedComponentName(),
                    posted_bag: this._editVue.getBagRaw(),
                    posted_isControlClick: action.getButtonClickContext().isCtlClick === true
                } as common.IHotEditableFormPostArguments,
                (data: IResponseData) => {
                    this.onFormActionSuccess(action, data);
                },
                (e, config) => {
                    this.onFormActionError(e, action, config);
                });
        };

        if (this._liveUpdateOnEditMode)
            // NOTE: ajout d'un delai afin de permettre aux plugins de se mettre a jour.
            setTimeout(() => {
                post();
            }, 100)
        else
            post();
    }

    private onFormActionSuccess(action: HotEditableFormAction, data?: IResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = isButtonClick && actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const hasCustomMessages = data.messages && data.messages.length;
        const buttonClickContext = action.getButtonClickContext();
        const changedFieldName = action.getFieldName();

        if (data.outdatedContent) {
            const onApply = data.outdatedContent.refreshEntirePage
                ? null
                : () => {
                    if (data.outdatedContent.hotEmbeddedComponentsToRefresh)
                        this._editVue.shared.updateHotEmbeddedComponents(data.outdatedContent.hotEmbeddedComponentsToRefresh);
                    else
                        this._editVue.shared.updateCurrentHotEmbeddedComponent();
                };

            this._pageService.validateResponseDataGlobal(data, onApply);
            return;
        }

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (!this._editVue.shared.displayMessage(name, text, messageType))
                this._formService.displayMessage(text, messageType, immediateDisplay, autoClose);
        }

        if (this._editVue.shared.isHotEmbeddedComponent()) {
            // Widgets -> brothers
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue.refreshBrotherEmbeddedComponents();
            else if (data.restoreBrotherEmbeddedComponents)
                this._editVue.restoreBrotherEmbeddedComponents();
            else if (data.ensureBrotherEmbeddedComponentsIsDefaultUrl)
                this._editVue.ensureBrotherEmbeddedComponentsIsDefaultUrl();
            // Widgets -> all
            if (data.hotEmbeddedComponentsToUpdate && data.hotEmbeddedComponentsToUpdate.length) {
                const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                if (showMessages)
                    if (updateCurrentEmbededForm)
                        if (hasCustomMessages)
                            for (let i = 0; i < data.messages.length; i++) {
                                const m = data.messages[i];
                                const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                                displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                            }
                        // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService.displayMessage(data.messages, customMessageType, true, true);
                        else if (showAutoSuccessMessages)
                            this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

                if (this._editVue && this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                    return;
            }
        }

        if (isDeleteAction) {
            var redirectUrl = data.redirectUrl;
            if (!redirectUrl && data.forceRedirectOnDeleteAction)
                redirectUrl = '/';
            if (redirectUrl) {
                utilities.redirect(redirectUrl);
                return;
            }
        }

        this._editVue.shared.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue.updateBag(data.bag);

        const repost = () => this._editVue.shared.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService.confirm(
            this._editVue.formManager.getFormName(),
            this._confirmPopup,
            data.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            returnToApiOnDenied => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }
                if (this._editVue.shared.confirmationRejected())
                    this._formService.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (data.searchPersonneResultOptions)
            this._editVue.setSearchPersonneResultOptions(data.searchPersonneResultOptions, data.searchPersonneResultSelectedOption);

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue.shared.updateFieldFromApi(updatedField);
            }

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || null;
            if (url) {
                if (showMessages)
                    if (hasCustomMessages)
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }
                    // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                    //     this._formService.displayMessage(data.messages, customMessageType, false, true);
                    else if (showAutoSuccessMessages)
                        this._formService.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                utilities.redirectWithOptions(url, data.redirectUrlOptions);
                return;
            }
        }

        this.updateDynamicFields(action);

        if (showMessages)
            if (hasCustomMessages)
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
            // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
            //     this._formService.displayMessage(data.messages, customMessageType, true, true);
            else if (showAutoSuccessMessages)
                this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

        if (isEditionFormMode && !this._isEditionAlwaysOn && !this._liveUpdateOnEditMode)
            this._editVue.shared.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue.shared.displayFieldError(this._editVue.shared.getFormName(), error, true);
            if (fieldFound) {
                this._formService.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService.displayErrorImediately(new core.Error(error.message));
        }
    }

    private updateDynamicFields(action: HotEditableFormAction) {
        if (!action)
            return;
        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        if (actionType === common.HotEditableActionTypes.apply)
            if (actionValue === "fusionner" || actionValue === "lier" || actionValue === "delier")
                this._editVue.$nextTick(() => {
                    this._editVue.updateFieldsFromPersonneLiee();
                    this._editVue.$nextTick(() => {
                        this._editVue.onEstPersonneMoralUpdate();
                        //this._editVue.onExemptionCotiUpdate();
                        //this._editVue.onExemptionVoteUpdate();
                    });
                });
    }
}

export = GestionPersonneFerme;